import { render, staticRenderFns } from "./ItemValidationRules.vue?vue&type=template&id=4012749d&lang=html"
import script from "./ItemValidationRules.vue?vue&type=script&lang=js"
export * from "./ItemValidationRules.vue?vue&type=script&lang=js"
import style0 from "./ItemValidationRules.vue?vue&type=style&index=0&id=4012749d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports